import { Link, useSearchParams } from "react-router-dom";
import { CheckCircle2, XCircle } from "lucide-react";

export default function CheckoutSuccess() {
  const [params] = useSearchParams();
  const paid = params.get("status") === "paid";

  return (
    <div className="container-lira py-32 min-h-[70vh] grid place-items-center text-center" data-testid="checkout-success-page">
      <div className="max-w-md">
        {paid ? (
          <>
            <CheckCircle2 strokeWidth={1} className="h-14 w-14 mx-auto text-[#1A1A1A]" />
            <h1 className="font-serif text-4xl md:text-5xl font-light mt-6">Thank you</h1>
            <p className="text-[#737373] mt-4">Your order has been confirmed and paid via PayPal. A receipt is on its way to your inbox.</p>
            <Link to="/collection/all" className="btn-primary mt-10 inline-flex" data-testid="continue-shopping-success">Continue Shopping</Link>
          </>
        ) : (
          <>
            <XCircle strokeWidth={1} className="h-14 w-14 mx-auto text-[#737373]" />
            <h1 className="font-serif text-3xl mt-6">Order not completed</h1>
            <p className="text-[#737373] mt-3">Your payment was not completed. Please try again.</p>
            <Link to="/cart" className="btn-primary mt-10 inline-flex">Back to Bag</Link>
          </>
        )}
      </div>
    </div>
  );
}
